import React from "react";
import NumberFormat from "react-number-format";

const NumberField = React.forwardRef(function NumberField(props, ref) {
  const { onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={ref}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      decimalScale={0}
      thousandSeparator=","
      decimalSeparator="."
    />
  );
});

export default NumberField;
